import { ROUTE_ENUM } from "enums";
import { NavigateFunction } from "react-router";
import { UserType } from "types/UsersTypes";

export default function checkIfLogged(
  authorizedUser: UserType | undefined,
  navigate: NavigateFunction
): void {
  if (authorizedUser) {
    navigate(ROUTE_ENUM.DASHBOARD);
  }
}
